import { HOME_CLEAR_CURRENT_LEAD } from './constants'
import { PRESUPUESTADOR_CLEAR_LEAD_PRESUPUESTADOR } from '../../presupuestador/redux/constants'
import _ from 'lodash'

export function clearCurrentLead() {
  return (dispatch) => {
    dispatch({
      type: PRESUPUESTADOR_CLEAR_LEAD_PRESUPUESTADOR,
    })
    dispatch({
      type: HOME_CLEAR_CURRENT_LEAD,
    })
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_CLEAR_CURRENT_LEAD:
      return {
        ...state,
        setCurrentLeadPending: false,
        setCurrentLeadError: null,
        client_lead: null,
        client_lead_app: null,
        client_lead_cleared: _.uniqBy([state.client_lead].concat(state.client_lead_cleared), 'id').slice(0, 5),
      }

    default:
      return state
  }
}
